import { useLabels } from '../../i18n/labels';
import type { BoutStatus } from '../../types';

/** The colour of the pill of each bout status. One map for every view: a live
 *  bout is green, a scored bout gray and a pending bout amber (#661). */
export const BOUT_STATUS_CLS: Record<BoutStatus, string> = {
  current: 'badge-green',
  scored: 'badge-gray',
  pending: 'badge-amber',
};

/** The status of a bout as a pill: the colour of `BOUT_STATUS_CLS` and the
 *  text of `statusLabel()` ("Live", "Scored", "Pending" / "Tiesiogiai",
 *  "Įvertinta", "Laukia"). `size="xs"` is for a dense table.
 *  `plainWhenPending` shows a pending bout as plain gray text with no pill. */
export default function BoutStatusPill({ status, size = 'sm', plainWhenPending = false, className = '' }: {
  status: BoutStatus;
  size?: 'xs' | 'sm';
  plainWhenPending?: boolean;
  className?: string;
}) {
  const { statusLabel } = useLabels();
  if (plainWhenPending && status === 'pending') return <span className="text-gray-400">{statusLabel(status)}</span>;
  return (
    <span className={`badge ${BOUT_STATUS_CLS[status] ?? 'badge-gray'} ${size === 'xs' ? 'text-xs' : ''} ${className}`.trim()}>
      {statusLabel(status)}
    </span>
  );
}
